import { BasePolicyStatus } from '../../../../../../coverpath-common/angular/components/account-center/policy-status/base-policy-status';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import type { CoverpathPolicy } from '../../../../../../coverpath-common/classes/coverpath_subclasses/CoverpathPolicy';
import { AccountCenterService } from '../../../../../../coverpath-common/angular/services/account-center/account-center.service';

export class CoverpathPolicyStatus extends BasePolicyStatus {
  policy: CoverpathPolicy;

  constructor(
    protected amorphicService: AmorphicService,
    policy: CoverpathPolicy,
    accountCenterService: AccountCenterService
  ) {
    super(amorphicService, policy, accountCenterService);
    this.policy = policy;
    this.accountCenterService = accountCenterService;
    if (!policy.isAnnuity()) {
      this.setAllProperties();
    }
  }

  setAllProperties() {
    super.setAllProperties();
    // overrides
    if (this.primaryPolicyData) {
      this.isJointApp = this.primaryPolicyData.getCACIsJointApp();
      this.advisorSignedApp = this.primaryPolicyData.getCACIsAdvisorSigned();
      this.contactNumber = this.primaryPolicyData.getCACContactNumber();
      this.hasAgent = true;
      this.insuredEsignRequired = this.primaryPolicyData.getCACIsInsuredESignRequired();
    }
  }
}
